import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import img1 from "../../assets/durbinnews-cover.JPG";
import img2 from "../../assets/ecommerce-platform-cover.JPG";
import img3 from "../../assets/reluxrent-cover.JPG";
import SectionTitle from "../../components/SectionTitle";
import { fadeIn } from "../../variants";

const projects = [
  {
    id: 1,
    img: img1,
    link: "/durbinnews",
    title: "Durbinnews",
    clickTitle: "Click on ",
    desc: "Button to See the Project Details...",
    fade: "left",
  },
  {
    id: 2,
    img: img2,
    link: "/ecommerce-platform",
    title: "Ecommerce Platform",
    clickTitle: "Click on ",
    desc: "Button to See the Project Details...",
    fade: "right",
  },
  {
    id: 3,
    img: img3,
    link: "/reluxrent",
    title: "Reluxrent",
    clickTitle: "Click on ",
    desc: "Button to See the Project Details...",
    fade: "left",
  },
];

const Projects = () => {
  return (
    <section className="min-h-[80vh] mt-10 lg:mt-20" id="projects">
      <div className="container mx-auto">
        <div className="md:grid grid-cols-2 gap-4">
          {/* Contents */}
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: true, amount: 0.3 }}
          >
            {/* Title */}
            <SectionTitle normalText={"My Latest"} coloredText={"Projects"} />
            {/* Paragraph */}
            <p className="pb-4 md:pb-0">
              I am excited to share with you the latest projects that I have
              been diligently working on. I have devoted countless hours to
              creating innovative and user-friendly web applications that aim to
              solve real-world problems and enhance user experiences.
            </p>
          </motion.div>
          {/* Projects */}
          {projects.map((project) => (
            <motion.div
              key={project.id}
              variants={fadeIn(project.fade, 0.3)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
            >
              <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl cursor-pointer z-40">
                {/* Overlay on hover */}
                <div className="group-hover:bg-black/70 w-full h-full absolute z-30 transition-all duration-300"></div>

                {/* Project Image */}
                <img
                  className="w-full min-h-[180px] lg:min-h-[270px] group-hover:scale-125 transition-all duration-500 object-cover"
                  src={project.img}
                  alt={project.title}
                />

                {/* Title / Description */}
                <div className="absolute inset-0 flex items-end group-hover:items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 z-50">
                  <span className="text-gradient text-center">
                    {project.clickTitle}{" "}
                    <span className="text-white text-base">{project.desc}</span>
                  </span>
                </div>
              </div>

              {/* View Details Button */}
              <Link to={project.link}>
                <button className="btn px-4 py-2 text-sm lg:text-base mt-2 mb-6 md:mb-0">
                  View Details
                </button>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
